import * as Sentry from '@sentry/react';
import { LoginResponse } from 'utils/api';
import { UtmParameters } from '../types';

/**
 * Gets a specified cookie off the window object, returning undefined if it doesn't exist otehrwise
 * returning parsed JS object.
 */
export const getCookie = (cookieName: string): Object | undefined => {
  const cookies = `; ${document.cookie}`;
  const parts = cookies.split(`; ${cookieName}=`);

  if (parts.length === 2) {
    try {
      return JSON.parse(parts[1].split(';')[0]);
    } catch (error) {
      Sentry.captureException(error, (scope) => {
        scope.setTransactionName(`Failed to parse cookie: ${parts}`);
        return scope;
      });
      return undefined;
    }
  } else {
    Sentry.captureMessage(`Failed to find cookie: ${cookieName}`);
  }

  return undefined;
};

/**
 * Adds UTM params from URL to passed UTM params.
 *
 * Prefers to use the ones from the URL, but will use passed value as backup.
 */
export const getUTMParameters = (): UtmParameters => {
  const urlParams = new URLSearchParams(window.location.search);
  const cookie = (getCookie('campaign_first') ?? {}) as any;

  const utmParameters: UtmParameters = {
    campaign: urlParams.get('utm_campaign') || cookie.utm_campaign || '',
    source: urlParams.get('utm_source') || cookie.utm_source || '',
    content: urlParams.get('utm_content') || cookie.utm_content || '',
    id: urlParams.get('utm_id') || cookie.utm_id || '',
    medium: urlParams.get('utm_medium') || cookie.utm_medium || '',
    referral: urlParams.get('utm_referral') || cookie.utm_referral || '',
    term: urlParams.get('utm_term') || cookie.utm_term || '',
  };

  return utmParameters;
};

export const reportSatelliteMissing = ({ shouldSendToSentry = false } = {}): false => {
  if (shouldSendToSentry) Sentry.captureMessage('AA - _satellite missing');
  console.warn('AA - _satellite missing'); // eslint-disable-line no-console
  return false;
};

export const reportUserDataMissing = ({
  user_id,
  company_id,
  company_name,
}: Pick<LoginResponse, 'company_id' | 'company_name' | 'user_id'>) => {
  const missingFields = [];
  if (!user_id) missingFields.push('user_id');
  if (!company_id) missingFields.push('company_id');
  if (!company_name) missingFields.push('company_name');

  if (missingFields.length === 0) return;

  let errorMessage = 'AA: ';
  if (missingFields.length === 3) {
    errorMessage += 'user_id, company_id and company_name not returned';
  } else {
    errorMessage += `${missingFields.join(' and ')} not returned`;
  }

  Sentry.captureMessage(errorMessage);
};
